// @ts-nocheck
import { CountryCodeInputProps } from "./CountryCodeInput.types";
import {
  CountryCodeWrapper,
  ChevronDropdownIcon,
  PhoneInputStyled,
} from "./CountryCodeInput.styles";

export const CountryCodeInput = (props: CountryCodeInputProps) => {
  const {
    countryCode,
    international = true,
    countryCallingCodeEditable = false,
    defaultCountry = "IN",
    smartCaret = false,
    readOnly = true,
    width = "fitContent",
    variant = "default",
    onChange = () => {},
  } = props;

  return (
    <CountryCodeWrapper variant={variant}>
      <PhoneInputStyled
        international={international}
        countryCallingCodeEditable={countryCallingCodeEditable}
        defaultCountry={defaultCountry}
        placeholder="Enter phone number"
        value={countryCode}
        smartCaret={smartCaret}
        readOnly={readOnly}
        disabled={false}
        width={width}
        onChange={onChange}
        className="phone-input"
      />
      <ChevronDropdownIcon className="fa-solid fa-caret-down"></ChevronDropdownIcon>
    </CountryCodeWrapper>
  );
};
